import { createActions } from 'redux-actions';
import { request, create, update } from '../../services';
import { getEstimatorPage, getEstimatorFilters } from '../../reducers';
import Schemas from 'schemas';
import { normalize } from 'normalizr';
import { push } from 'react-router-redux';
import { navigateBack } from 'actionCreators';
import qs from 'qs';

const {
  estimatorListRequest,
  estimatorListSuccess,
  estimatorListFailure,
} = createActions({
  ESTIMATOR_LIST_SUCCESS: json => normalize(json, { estimators: Schemas.ESTIMATOR_ARRAY }),
}, 'ESTIMATOR_LIST_REQUEST', 'ESTIMATOR_LIST_FAILURE');

export function requestEstimatorList() {
  return (dispatch, getState) => {
    const state = getState();
    const page = getEstimatorPage(state);
    const filterParams = qs.stringify(getEstimatorFilters(state));
    dispatch(estimatorListRequest());
    return request(`estimators?page=${page}&${filterParams}`)
      .then(({ json }) => dispatch(estimatorListSuccess(json)))
      .catch(error => dispatch(estimatorListFailure(error)));
  };
}

export function setEstimatorFilters(filter) {
  return dispatch => (
    Promise.all([
      dispatch({ type: 'ESTIMATOR_SET_FILTER', payload: filter }),
      dispatch({ type: 'ESTIMATOR_RESET_PAGINATION' }),
      dispatch(requestEstimatorList()),
    ])
  );
}

const {
  estimatorResourceRequest,
  estimatorResourceSuccess,
  estimatorResourceFailure,
} = createActions({
  ESTIMATOR_RESOURCE_REQUEST: id => ({ id }),
  ESTIMATOR_RESOURCE_SUCCESS: json => normalize(json, Schemas.ESTIMATOR),
}, 'ESTIMATOR_RESOURCE_FAILURE');

export function requestEstimator(id) {
  return (dispatch) => {
    dispatch(estimatorResourceRequest(id));
    return request(`estimators/${id}`)
      .then(({ json }) => dispatch(estimatorResourceSuccess(json)))
      .catch(error => dispatch(estimatorResourceFailure(error)));
  };
}


const {
  estimatorResourceCreateRequest,
  estimatorResourceCreateSuccess,
  estimatorResourceCreateFailure,
} = createActions({
  ESTIMATOR_RESOURCE_CREATE_SUCCESS: json => normalize(json, Schemas.ESTIMATOR),
}, 'ESTIMATOR_RESOURCE_CREATE_REQUEST', 'ESTIMATOR_RESOURCE_CREATE_FAILURE');

export function createEstimator(estimator) {
  return (dispatch) => {
    dispatch(estimatorResourceCreateRequest());
    return create('estimator', estimator)
    .then(({ json }) =>
      Promise.all([
        dispatch(estimatorResourceCreateSuccess(json)),
        dispatch(push('/estimators')),
      ]),
    )
    .catch(error => dispatch(estimatorResourceCreateFailure(error)));
  };
}


const {
  estimatorResourceUpdateRequest,
  estimatorResourceUpdateSuccess,
  estimatorResourceUpdateFailure,
} = createActions({
  ESTIMATOR_RESOURCE_UPDATE_SUCCESS: json => normalize(json, Schemas.ESTIMATOR),
}, 'ESTIMATOR_RESOURCE_UPDATE_REQUEST', 'ESTIMATOR_RESOURCE_UPDATE_FAILURE');

export function updateEstimator(estimator) {
  return (dispatch) => {
    dispatch(estimatorResourceUpdateRequest(estimator));
    return update('estimator', estimator)
      .then(({ json }) =>
        Promise.all([
          dispatch(estimatorResourceUpdateSuccess(json)),
          dispatch(navigateBack()),
        ]),
      )
      .catch(error => dispatch(estimatorResourceUpdateFailure(error)));
  };
}

const {
  estimatorResourceForZipCodeRequest,
  estimatorResourceForZipCodeSuccess,
  estimatorResourceForZipCodeFailure,
} = createActions('ESTIMATOR_RESOURCE_FOR_ZIP_CODE_REQUEST',
 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_SUCCESS', 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_FAILURE');

export const getEstimatorsForZipCode = zipCode => (
  (dispatch) => {
    dispatch(estimatorResourceForZipCodeRequest(zipCode));
    return request(`estimators/for_zip_code/${zipCode}`)
    .then(({ json }) => dispatch(estimatorResourceForZipCodeSuccess(json)))
    .catch(error => dispatch(estimatorResourceForZipCodeFailure(error)));
  }
);

const {
  addEventToEstimatorRequest,
  addEventToEstimatorSuccess,
  addEventToEstimatorFailure,
} = createActions({
  ADD_EVENT_TO_ESTIMATOR_SUCCESS: (json, estimatorId) => ({ event: json.event, estimatorId }),
}, 'ADD_EVENT_TO_ESTIMATOR_FAILURE', 'ADD_EVENT_TO_ESTIMATOR_REQUEST');

export const addEventToEstimator = (estimatorId, event) => (dispatch) => {
  dispatch(addEventToEstimatorRequest(event));
  return request(`estimators/${estimatorId}/events`, { method: 'POST', body: event })
    .then(({ json }) => dispatch(addEventToEstimatorSuccess(json, estimatorId)))
    .catch(errors => dispatch(addEventToEstimatorFailure(errors)));
};

export function resetEstimatorFilters() {
  return dispatch => (
    Promise.all([
      dispatch({ type: 'ESTIMATOR_RESET_FILTERS' }),
      dispatch({ type: 'ESTIMATOR_RESET_PAGINATION' }),
      dispatch(requestEstimatorList()),
    ])
  );
}

export function sendEstimatorEmail(id, week) {
  const req = { method: 'POST', body: { week } };
  return request(`estimators/${id}/send_email`, req);
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/estimators.js